import svg4everybody from 'svg4everybody'
import $ from 'jquery'

import './vendor/jquery-validation'
import './vendor/masked-input'

svg4everybody()

window.$ = $
window.jQuery = $
